import { Trans, t } from '@lingui/macro'
import { Avatar, Chip, Divider, Grid, IconButton, Stack, Typography, Box, CardContent, Card, Tooltip } from '@mui/material'
import CloseIcon from '@mui/icons-material/Close'
import PersonIcon from '@mui/icons-material/Person'
import { deepOrange, deepPurple } from '@mui/material/colors'

import { Patient } from '@/core/models/patient.model'
import { useIsUS } from '@/hooks/useIsUS'

export type PatientSelectionCardProps = {
  patient: Patient
  type: 'primary' | 'secondary'
  onUnselect: (id: string) => void
}

export default function PatientSelectionCard({ patient, type, onUnselect }: PatientSelectionCardProps) {
  const isUS = useIsUS()
  return (
    <Card
      elevation={3}
      sx={{
        position: 'relative',
        border: type === 'primary' ? '2px solid' : '2px dashed',
        borderColor: type === 'primary' ? deepOrange[500] : deepPurple[500],
      }}
    >
      <Tooltip title={t`Remove patient`}>
        <IconButton
          size="small"
          sx={{ position: 'absolute', top: 8, right: 8 }}
          onClick={() => {
            onUnselect(patient._id)
          }}
        >
          <CloseIcon />
        </IconButton>
      </Tooltip>

      <CardContent>
        <Stack spacing={2}>
          <Stack direction="row" alignItems="center" spacing={2}>
            <Avatar sx={{ bgcolor: type === 'primary' ? deepOrange[500] : deepPurple[500], width: 56, height: 56 }}>
              <PersonIcon />
            </Avatar>
            <Box>
              <Typography variant="h6">
                {patient?.userInfo?.name} {patient?.userInfo?.surname}
              </Typography>
              <Chip label={type === 'primary' ? t`Primary Patient` : t`Secondary Patient`} size="small" color={type === 'primary' ? 'primary' : 'secondary'} />
            </Box>
          </Stack>
          <Divider />
          <Grid container spacing={1}>
            <Grid item xs={6}>
              <Typography variant="caption" color="text.secondary">
                <Trans>Email</Trans>
              </Typography>
              <Typography variant="body2">{patient?.email || '-'}</Typography>
            </Grid>
            <Grid item xs={6}>
              <Typography variant="caption" color="text.secondary">
                <Trans>Phone</Trans>
              </Typography>
              <Typography variant="body2">{patient?.contactInfo?.phone || '-'}</Typography>
            </Grid>
            <Grid item xs={6}>
              <Typography variant="caption" color="text.secondary">
                {isUS ? <Trans>Primary Policy #</Trans> : <Trans>Social security number</Trans>}
              </Typography>
              <Typography variant="body2">{(isUS ? patient?.primaryPolicy : patient?.secu) || '-'}</Typography>
            </Grid>
            <Grid item xs={6}>
              <Typography variant="caption" color="text.secondary">
                <Trans>City</Trans>
              </Typography>
              <Typography variant="body2">{patient?.contactInfo?.city || '-'}</Typography>
            </Grid>
          </Grid>
        </Stack>
      </CardContent>
    </Card>
  )
}
